import { PipelineWidget } from "@/components/dashboard/PipelineWidget"

export default function Pipeline() {
  return (
    <div className="space-y-4 sm:space-y-6 p-3 sm:p-4 md:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground">CRM Clientes</h1>
          <p className="text-sm sm:text-base text-muted-foreground">Gestão completa do funil de vendas</p>
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        <PipelineWidget />
      </div>
    </div>
  )
}
